import SectionHeading from '@/components/base/SectionHeading';
import { principles } from '@/mocks/site';

export default function TrustSection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="内容原则"
          title="我们怎样对待每一条线索"
          desc="观察类内容的可信度，取决于处理信息的方式。以下四条是我们所有条目的共同前提。"
          align="center"
        />

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((item, index) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span className="font-heading text-2xl font-black text-background-300">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}